import * as types from './types';

const initialState = {
  invoiceTemplates: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_INVOICE_TEMPLATES:
      return { invoiceTemplates: action.data };
    case types.GET_INVOICE_TEMPLATES:
      // Falls through.
    default:
      return state;
  }
};
